<template>
  <section class="dia">
    <div class="dia__glow dia__glow--orange" aria-hidden="true"></div>
    <div class="dia__dots" aria-hidden="true"></div>

    <div class="dia__container">
      <div class="dia__head reveal">
        <h2 class="dia__title">{{ $t('deja_assure.header') }}</h2>
        <span class="dia__bar"></span>
      </div>

      <div class="dia__grid reveal">
        <!-- Formulaire de comparaison -->
        <div class="dia__form">
          <div class="dia__form-header">
            <h3>{{ $t('deja_assure.title') }}</h3>
            <p>{{ $t('deja_assure.intro') }}</p>
          </div>

          <div v-if="showFormStep1" class="dia__step">
            <span class="dia__step-badge">1/2</span>

            <div class="dia__field">
              <label class="dia__label">{{ $t('deja_assure.type_contrat_label') }} *</label>
              <select v-model="alreadyInsuredData.typeContrat" class="dia__control">
                <option value="Automobile">Automobile</option>
                <option value="Habitation">Habitation</option>
                <option value="Sante">Santé</option>
                <option value="Multirisque Professionnelle">Multirisque Professionnelle</option>
                <option value="Responsabilité Civile Professionnelle">Responsabilité Civile Professionnelle</option>
              </select>
            </div>

            <div class="dia__row">
              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.nombre_mois_label') }} *</label>
                <select v-model="alreadyInsuredData.nbreMois" class="dia__control">
                  <option value="" disabled>Cliquez pour sélectionner</option>
                  <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                </select>
              </div>

              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.prime_label') }} *</label>
                <input
                  v-money="money"
                  @keypress="onlyNumber"
                  type="text"
                  v-model="alreadyInsuredData.primeActuelle"
                  :placeholder="$t('deja_assure.prime_placeholder')"
                  class="dia__control"
                />
              </div>
            </div>

            <button class="dia__btn dia__btn--primary" @click="nextStep">
              {{ $t('deja_assure.bouton_suivant_label') }} <i class="fas fa-arrow-right"></i>
            </button>
          </div>

          <div v-if="showFormStep2" class="dia__step">
            <span class="dia__step-badge">2/2</span>

            <div class="dia__row">
              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.nom_label') }} *</label>
                <select v-model="alreadyInsuredData.nomAssureur" class="dia__control">
                  <option v-for="item in partenaireMetier" :key="item.value" :value="item.value">{{ item.name }}</option>
                </select>
              </div>

              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.date_label') }} *</label>
                <input type="date" v-model="alreadyInsuredData.endDate" class="dia__control" />
              </div>
            </div>

            <div class="dia__field" v-if="alreadyInsuredData.nomAssureur == 'AUTRE'">
              <label class="dia__label">{{ $t('deja_assure.Autre_label') }} *</label>
              <input type="text" v-model="alreadyInsuredData.autreNomAssureur" class="dia__control" placeholder="" />
            </div>

            <div class="dia__row">
              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.first_name_label') }} *</label>
                <input
                  type="text"
                  v-model="alreadyInsuredData.firstname"
                  :placeholder="$t('deja_assure.first_name_placeholder')"
                  class="dia__control"
                />
              </div>

              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.last_name_label') }} *</label>
                <input
                  type="text"
                  v-model="alreadyInsuredData.lastname"
                  :placeholder="$t('deja_assure.last_name_placeholder')"
                  class="dia__control"
                />
              </div>
            </div>

            <div class="dia__row">
              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.telephone_label') }} *</label>
                <div class="dia__phone">
                  <CountryCodeSelect
                    :value="alreadyInsuredData.countryCode"
                    @input="alreadyInsuredData.countryCode = $event"
                    search-placeholder="Sénégal"
                  />
                  <input
                    @keypress="onlyNumber"
                    v-model="alreadyInsuredData.telephone"
                    :placeholder="$t('deja_assure.telephone_placeholder')"
                    class="dia__control dia__phone-input"
                  />
                </div>
              </div>

              <div class="dia__field">
                <label class="dia__label">{{ $t('deja_assure.adresse_mail') }} *</label>
                <input
                  type="text"
                  v-model="alreadyInsuredData.email"
                  :placeholder="$t('deja_assure.adresse_mail_placeholder')"
                  class="dia__control"
                />
              </div>
            </div>

            <div class="dia__field">
              <label class="dia__label">{{ $t('deja_assure.is_from_broker_label') }}</label>
              <v-switch
                v-model="alreadyInsuredData.isFromBroker"
                color="#ffa409"
                class="dia__switch"
                :label="`${alreadyInsuredData.isFromBroker ? $t('deja_assure.oui_label') : $t('deja_assure.non_label')}`"
              ></v-switch>
            </div>

            <div class="dia__actions">
              <button class="dia__btn dia__btn--ghost" @click="backStep">
                <i class="fas fa-arrow-left"></i> {{ $t('deja_assure.bouton_retour_label') }}
              </button>
              <button class="dia__btn dia__btn--primary" @click="sending">
                {{ $t('deja_assure.bouton_envoyer_label') }} <i class="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>

          <p class="dia__note"><span>*</span> {{ $t('deja_assure.champs_obligatoire_label') }}</p>
        </div>

        <!-- Visuel -->
        <div class="dia__visual">
          <div class="dia__visual-card">
            <img src="../../../assets/img/already_insured.png" alt="Déjà assuré ailleurs" loading="lazy" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogLoading" class="dia__loading">
      <span class="dia__spinner"></span>
      <span class="dia__loading-text">{{ $t('deja_assure.envoie_en_cours_label') }}</span>
    </div>
  </section>
</template>

<script>
import Api from '../../../services/Api';
import PartenaireMetier from '../../../common/PartenaireMetier.json';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import IntlNumber from '../../../common/intlNumber.json';
import CountryCodeSelect from '../../../views/CountryCodeDejaAssure.vue';

const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour l'indicatif ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour l'indicatif ${countryCode}` };
    }
};

const validateEmail = email => {
    if (!email.length) {
        return { valid: false, error: "L'adresse mail est obligatoire!" };
    } else if (!email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
        return { valid: false, error: "Veuillez entrer un email valide!" };
    } else {
        return { valid: true, error: null };
    }
};

export default {
  name: 'already_insured',
  components: {
    CountryCodeSelect
  },
  data: () => ({
    partenaireMetier: PartenaireMetier,
    intlNumber: IntlNumber,
    dialogLoading: false,
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
    showFormStep1: true,
    showFormStep2: false,
    step: 1,
    alreadyInsuredData: {
      autreNomAssureur: null,
      nomAssureur: null,
      typeContrat: null,
      endDate: null,
      nbreMois: null,
      primeActuelle: null,
      firstname: null,
      lastname: null,
      fullName: null,
      telephone: null,
      email: null,
      isFromBroker: null,
      countryCode: '+221'
    },
    money: {
      thousands: ' ',
      precision: false,
      masked: false,
    },
    ToastTabSucess: {
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'success',
      className: 'custom-success-class'
    },
    ToastTabError: {
      theme: "toasted-primary",
      position: "top-center",
      duration: 7000,
      fitToScreen: true,
      type: 'error'
    },
  }),

  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    nextStep() {
      if (!this.alreadyInsuredData.typeContrat || !this.alreadyInsuredData.primeActuelle || !this.alreadyInsuredData.nbreMois) {
        this.$toasted.show("Les champs * sont obligatoire", this.ToastTabError);
        return;
      }

      this.showFormStep2 = true;
      this.showFormStep1 = false;
    },

    backStep() {
      this.showFormStep2 = false;
      this.showFormStep1 = true;
    },

    clearForm() {
      this.alreadyInsuredData.nomAssureur = null
      this.alreadyInsuredData.typeContrat = null
      this.alreadyInsuredData.nbreMois = null
      this.alreadyInsuredData.endDate = null
      this.alreadyInsuredData.primeActuelle = null
      this.alreadyInsuredData.firstname = null
      this.alreadyInsuredData.lastname = null
      this.alreadyInsuredData.telephone = null
      this.alreadyInsuredData.email = null
    },

    async sendingControl() {
      let errors = {}
      const validPhone = validatePhoneWithIndicatif(this.alreadyInsuredData.telephone, this.alreadyInsuredData.countryCode);
      errors.phone = validPhone.error;

      if (validPhone.valid == true) {
        this.sending()
      } else {
        this.$toasted.show(validPhone.error, this.ToastTabError);
        return
      }
    },

    sending() {
      if (!this.alreadyInsuredData.firstname || !this.alreadyInsuredData.lastname || !this.alreadyInsuredData.telephone || !this.alreadyInsuredData.nomAssureur || !this.alreadyInsuredData.endDate || !this.alreadyInsuredData.email) {
        this.$toasted.show("Les champs * sont obligatoire", this.ToastTabError);
        return;
      }

      if (this.alreadyInsuredData.nomAssureur === 'AUTRE' && !this.alreadyInsuredData.autreNomAssureur) {
        this.$toasted.show("Le champ Autre assureur est obligatoire", this.ToastTabError);
        return;
      } else {
        this.alreadyInsuredData.autreNomAssureur = '';
      }

      // Check if selected date is not in the past
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time part for date comparison
      const selectedDate = new Date(this.alreadyInsuredData.endDate);

      if (selectedDate < today) {
        this.$toasted.show("La date de fin ne peut pas être dans le passé", this.ToastTabError);
        return;
      }

      let errors = {}
      const validEmail = validateEmail(this.alreadyInsuredData.email);
      errors.email = validEmail.error;

      if (validEmail.valid != true) {
        this.$toasted.show(validEmail.error, this.ToastTabError);
        return
      }

      const validPhone = validatePhoneWithIndicatif(this.alreadyInsuredData.telephone, this.alreadyInsuredData.countryCode);
      errors.phone = validPhone.error;

      if (validPhone.valid != true) {
        this.$toasted.show(validPhone.error, this.ToastTabError);
        return
      }

      // sending data to Api for getting Response
      const isFromBroker = this.alreadyInsuredData.isFromBroker ? 'OUI' : 'NON';
      let numberClient = (this.alreadyInsuredData.countryCode + this.alreadyInsuredData.telephone).substring(1)

      let alreadyInsuredData = {
        nomAssureur: this.alreadyInsuredData.nomAssureur,
        autreNomAssureur: this.alreadyInsuredData.autreNomAssureur,
        typeContrat: this.alreadyInsuredData.typeContrat,
        endDate: this.alreadyInsuredData.endDate,
        nbreMois: this.alreadyInsuredData.nbreMois,
        primeActuelle: this.alreadyInsuredData.primeActuelle,
        firstname: this.alreadyInsuredData.firstname,
        lastname: this.alreadyInsuredData.lastname,
        telephone: numberClient,
        email: this.alreadyInsuredData.email,
        is_from_broker: isFromBroker,
        plateforme: "Front",
      }
      this.dialogLoading = true

      Api().post('message/dejaassure', alreadyInsuredData)
        .then(() => {
          setTimeout(() => {
            this.dialogLoading = false
            this.clearForm()
            this.$toasted.show("Merci, les données ont été envoyé avec succès", this.ToastTabSucess);
            this.showFormStep2 = false;
            this.showFormStep1 = true;
          }, 3000);
        }).catch(() => {
          setTimeout(() => {
            this.dialogLoading = false
            this.$toasted.show("Une erreur est survenue, veuillez réessayer", this.ToastTabError);
          }, 3000);
        })
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.dia {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #FFFBF6 0%, #fff 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.4;
    pointer-events: none;

    &--orange {
      width: 440px;
      height: 440px;
      background: rgba(255, 164, 9, 0.24);
      top: -150px;
      right: -120px;
    }
  }

  &__dots {
    position: absolute;
    bottom: 8%;
    left: 4%;
    width: 120px;
    height: 120px;
    background-image: radial-gradient(rgba(91, 148, 188, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 52px;
  }

  &__title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 18px;
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 0.85fr;
    gap: 48px;
    align-items: center;
  }

  &__form {
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 26px;
    padding: 38px;
    box-shadow: 0 22px 56px rgba(43, 43, 43, 0.09);
  }

  &__form-header {
    margin-bottom: 28px;

    h3 {
      margin: 0 0 8px;
      font-size: 21px;
      font-weight: 800;
      line-height: 1.35;
      color: #2b2b2b;
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      color: #59595b;
    }
  }

  &__step {
    position: relative;
  }

  &__step-badge {
    position: absolute;
    top: -8px;
    right: 0;
    background: #fff3df;
    color: #b06d00;
    font-size: 12px;
    font-weight: 700;
    padding: 5px 12px;
    border-radius: 999px;
  }

  &__row {
    display: flex;
    gap: 16px;
  }

  &__field {
    flex: 1;
    min-width: 0;
    margin-bottom: 18px;
  }

  &__label {
    display: block;
    margin-bottom: 7px;
    font-size: 14px;
    font-weight: 700;
    color: #2b2b2b;
  }

  &__control {
    width: 100%;
    padding: 13px 16px;
    border: 1.5px solid #e5e5e5;
    border-radius: 12px;
    font-size: 15px;
    color: #2b2b2b;
    background: #fff;
    outline: none;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;

    &::placeholder {
      color: #898d8f;
    }

    &:focus {
      border-color: #ffa409;
      box-shadow: 0 0 0 4px rgba(255, 164, 9, 0.14);
    }
  }

  select.dia__control {
    cursor: pointer;
  }

  &__phone {
    display: flex;
    align-items: center;
    gap: 10px;

    .country-code-select {
      flex-shrink: 0;
    }
  }

  &__phone-input {
    flex: 1;
  }

  &__switch {
    margin: 0;
  }

  &__actions {
    display: flex;
    gap: 12px;
    margin-top: 6px;
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: none;
    cursor: pointer;
    padding: 15px 26px;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 700;
    transition: transform 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;

    i {
      font-size: 13px;
    }

    &--primary {
      width: 100%;
      background: linear-gradient(135deg, #ffb33d 0%, #ffa409 55%, #f57c00 100%);
      color: #fff;
      box-shadow: 0 12px 28px rgba(255, 164, 9, 0.35);

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 18px 36px rgba(255, 164, 9, 0.42);
      }
    }

    &--ghost {
      flex: 1;
      background: #f5f5f5;
      color: #333;

      &:hover {
        background: #e8e8e8;
      }
    }
  }

  &__note {
    margin: 22px 0 0;
    font-size: 13px;
    color: #898d8f;

    span {
      color: #f57c00;
      font-weight: 700;
    }
  }

  &__visual-card {
    background: linear-gradient(150deg, #fff3df 0%, #eaf3f9 100%);
    border-radius: 26px;
    padding: 20px;
    box-shadow: 0 22px 56px rgba(43, 43, 43, 0.08);

    img {
      width: 100%;
      object-fit: contain;
      border-radius: 18px;
    }
  }

  &__loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  &__spinner {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 5px solid #ddd;
    border-top-color: #ffa409;
    animation: dia-spin 1s linear infinite;
  }

  &__loading-text {
    color: #fff;
    font-weight: bold;
  }
}

@keyframes dia-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 991px) {
  .dia {
    padding: 72px 24px;

    &__grid {
      grid-template-columns: 1fr;
      gap: 32px;
    }

    &__visual {
      display: none;
    }

    &__title {
      font-size: 32px;
    }
  }
}

@media (max-width: 600px) {
  .dia {
    padding: 56px 20px;

    &__form {
      padding: 26px 20px;
      border-radius: 22px;
    }

    &__row {
      flex-direction: column;
      gap: 0;
    }

    &__actions {
      flex-direction: column;
    }
  }
}

</style>
